/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CalendarDto } from './calendar.dto';
import { CalendarMapper } from './calendar.mapper';

@Injectable()
export class CalendarRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAll(): Observable<CalendarDto> {
    return this.httpGet(`${this.bp}/calendar`, CalendarMapper);
  }

  findAllByYear(year: number): Observable<CalendarDto> {
    return this.httpGet(`${this.bp}/calendar/${year}`, CalendarMapper);
  }

  update(calendar: CalendarDto): Observable<void> {
    return this.httpPut(`${this.bp}/calendar`, calendar, CalendarMapper, none());
  }
}
